<div class="cmdk-spaceprev">
  <div class="cmdk-spaceprev__head">
    <div class="cmdk-spaceprev__ident">
      <h3 class="cmdk-spaceprev__title">{{ item().title }}</h3>
      <p class="cmdk-spaceprev__kind">{{ item().spaceType }}</p>
    </div>
    @if (tagLabel(); as label) {
      <paper-tag [intent]="tagIntent()" size="sm">{{ label }}</paper-tag>
    }
  </div>

  @if (unknownNote(); as note) {
    <p class="cmdk-spaceprev__note">{{ note }}</p>
  }

  <section class="cmdk-spaceprev__section">
    <h4 class="cmdk-spaceprev__section-title">{{ detailsLabel() }}</h4>
    <dl class="cmdk-spaceprev__facts">
      @for (fact of facts(); track fact.label) {
        <div class="cmdk-spaceprev__fact">
          <dt>{{ fact.label }}</dt>
          <dd>{{ fact.value }}</dd>
        </div>
      }
    </dl>
  </section>

  @if (amenities().length) {
    <section class="cmdk-spaceprev__section">
      <h4 class="cmdk-spaceprev__section-title">{{ amenitiesLabel() }}</h4>
      <ul class="cmdk-spaceprev__amenities">
        @for (amenity of amenities(); track amenity) {
          <li class="cmdk-spaceprev__amenity">{{ amenity }}</li>
        }
      </ul>
    </section>
  }

  <div class="cmdk-spaceprev__actions">
    <paper-button
      intent="primary"
      size="sm"
      data-testid="cmdk-preview-run"
      (click)="activated.emit()">
      {{ openLabel() }}
    </paper-button>
    <paper-kbd keys="↵" label="Enter" size="sm" />
  </div>
</div>
